export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[560px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20minimal%20editorial%20background%20of%20layered%20warm%20paper%20textures%20in%20soft%20clay%20and%20sand%20tones%2C%20faint%20geometric%20linework%20and%20subtle%20grain%2C%20gentle%20shadow%20gradients%2C%20calm%20and%20airy%20negative%20space%20for%20overlaid%20text%2C%20no%20people%2C%20no%20text%2C%20high%20detail%2C%20harmonized%20muted%20palette&width=1600&height=1000&seq=hl-hero-01&orientation=landscape"
          alt="黑料网站同类平替对比参考的主视觉背景"
          title="黑料网站 同类 平替 对比 参考"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/45 via-foreground-950/35 to-foreground-950/55" />

      <div className="relative z-10 w-full px-4 md:px-8 py-24 md:py-32 flex flex-col items-center text-center">
        <span className="animate-fade-in inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full border border-background-50/30 bg-background-50/10 text-background-50/90 text-xs md:text-sm mb-6">
          <span className="w-3.5 h-3.5 flex items-center justify-center">
            <i className="ri-compasses-2-line" />
          </span>
          同类 · 平替 · 相似 · 对比 先看清差别
        </span>

        <h1 className="animate-fade-up font-heading font-semibold text-background-50 text-3xl md:text-5xl lg:text-6xl leading-[1.25] tracking-tight max-w-4xl">
          黑料网站 · 换一家之前，先把差别看明白
        </h1>

        <p className="animate-fade-up mt-6 md:mt-8 text-background-50/85 text-sm md:text-base leading-relaxed max-w-2xl">
          这里不做结论，只做一份安静的对比参考索引。把同类、平替、相似、对比、新选择这几件事摊开来看，
          省得在相似的站点之间来回试错，也更容易找到适合自己的那一个。
        </p>

        <div className="animate-fade-up mt-9 md:mt-11 w-full flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#index"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            先看差异索引
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-down-line" />
            </span>
          </a>
          <a
            href="#guide"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-50/40 text-background-50 text-sm whitespace-nowrap hover:bg-background-50/10 transition-colors cursor-pointer"
          >
            平替与新选择怎么挑
          </a>
        </div>

        <div className="animate-fade-in mt-14 md:mt-20 w-full max-w-3xl grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-4">
          {[
            { value: '6', label: '可感知差别维度' },
            { value: '3', label: '换一家前硬条件' },
            { value: '7', label: '建议试用天数' },
          ].map((item) => (
            <div key={item.label} className="flex flex-col items-center">
              <span className="font-heading text-3xl md:text-4xl text-background-50">{item.value}</span>
              <span className="mt-1 text-xs md:text-sm text-background-50/75">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}